import { render, staticRenderFns } from "./NavPoint.vue?vue&type=template&id=bfc79b80&scoped=true&"
import script from "./NavPoint.vue?vue&type=script&lang=js&"
export * from "./NavPoint.vue?vue&type=script&lang=js&"
import style0 from "./NavPoint.vue?vue&type=style&index=0&id=bfc79b80&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc79b80",
  null
  
)

export default component.exports